export default "__VITE_ASSET__DA$QioNm__"